import { patientDetailsClient } from '@/api/patients/patientDetailsClient';
import { QueryKey } from '@/data/query';
import type { GetPatientDetailsDto } from '@montugroup/pms-api-contracts';

export enum PatientDetailsIncludeEnum {
  BasicInfo = 'patient-basic-info',
  EmergencyContact = 'patient-emergency-contact',
  RedFlagInfo = 'patient-red-flag-info',
  IdentificationInfo = 'patient-identification-info',
  MedicalInfo = 'patient-medical-info',
  CareInfo = 'patient-care-info',
  ContactDetails = 'patient-contact-details',
}

export type PatientDetailsData = GetPatientDetailsDto;

const allPatientDetailsEndpoints: string = [
  PatientDetailsIncludeEnum.BasicInfo,
  PatientDetailsIncludeEnum.EmergencyContact,
  PatientDetailsIncludeEnum.MedicalInfo,
  PatientDetailsIncludeEnum.CareInfo,
  PatientDetailsIncludeEnum.IdentificationInfo,
  PatientDetailsIncludeEnum.RedFlagInfo,
  PatientDetailsIncludeEnum.ContactDetails,
].join(',');

const queryClient = patientDetailsClient();

export const useGetPatientDetails = (
  patientId: number | undefined,
  endpoints: string | undefined = allPatientDetailsEndpoints,
) => {
  const queryResult = queryClient.getPatientDetails.useQuery({
    queryKey: [QueryKey.GetPatientDetails, patientId, endpoints],
    queryData: {
      params: { id: Number(patientId) },
      query: { includes: endpoints },
    },
    enabled: Boolean(patientId),
    refetchOnMount: true,
  });

  return {
    result: queryResult,
    isError: queryResult.isError,
    isLoading: queryResult.isLoading,
    refetch: queryResult.refetch,
  };
};
